angular.module('document')
    .component('documentTypeLabel', {
        bindings: {
            type: '<'
        },
        template: `<span class="label label-default document-type-label" ng-style="$ctrl.type.color && { 'background-color': $ctrl.type.color }">{{$ctrl.type.name}}</span>`
    })
